import Bugsnag from '@bugsnag/js';

export function bugsnagDiagnosticData(event) {
  const { app: { releaseStage } = {} } = event || {};
  if (
    (releaseStage || '').includes('nightly') ||
    process.env.NODE_ENV !== 'production'
  ) {
    return false;
  }
  let userId;
  let userName;
  let userEmail;
  let orgId;
  let orgName;
  try {
    const { id, firstName, lastName, loginName, proxyOrgList } = JSON.parse(
      window.localStorage.getItem('user'),
    );
    orgId = window.localStorage.getItem('orgID');
    userId = id;
    userName = `${firstName} ${lastName}`;
    userEmail = loginName;
    orgName = proxyOrgList.find(
      ({ orgID }) => orgID === Number(orgId)?.orgName || '',
    );
  } catch (error) {
    userId = '';
    userName = '';
    userEmail = '';
    orgId = '';
    orgName = '';
  }
  event.addMetadata('org', {
    name: orgName,
    id: orgId,
  });
  event.setUser(userId, userEmail, userName);
}

export function notifyHandledException(error) {
  if (error) {
    Bugsnag.notify(new Error(error), function(event) {
      bugsnagDiagnosticData(event);
    });
  }
}
